'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAperture = function IoAperture(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m10.6 28.1c2.8-2.8 4.4-6.6 4.4-10.6s-1.6-7.8-4.4-10.6-6.6-4.4-10.6-4.4-7.8 1.6-10.6 4.4-4.4 6.6-4.4 10.6 1.6 7.8 4.4 10.6 6.6 4.4 10.6 4.4 7.8-1.6 10.6-4.4z m-15-22.3l4.4 6.7h-11.5c1.3-3.1 3.9-5.5 7.1-6.7z m16.7 14.2h-8l5.6-10.1c1.7 2.1 2.6 4.7 2.6 7.6 0 0.9-0.1 1.7-0.2 2.5z m-4.2-12l-3.8 7-6.1-9.8c0.6-0.1 1.2-0.2 1.8-0.2 3.1 0 5.9 1.1 8.1 3z m-20.4 7h8l-5.6 10.1c-1.7-2.1-2.6-4.7-2.6-7.6 0-0.9 0.1-1.7 0.2-2.5z m16.7 14.2l-4.4-6.7h11.5c-1.3 3.1-3.9 5.5-7.1 6.7z m-12.5-2.2l3.8-7 6.1 9.8c-0.6 0.1-1.2 0.2-1.8 0.2-3.1 0-5.9-1.1-8.1-3z' })
        )
    );
};

exports.default = IoAperture;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/aperture.js
// module id = 1929
// module chunks = 0